import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chipSection", "ratingSection", "chipTab", "ratingTab"]

  connect() {
    this.showMode(this.hasRatingSectionTarget && !this.ratingSectionTarget.hidden ? "rating" : "chips")
  }

  showChips(event) {
    event?.preventDefault()
    this.showMode("chips")
  }

  showRating(event) {
    event?.preventDefault()
    this.showMode("rating")
  }

  showMode(mode) {
    const showingRating = mode === "rating"

    this.ratingSectionTarget.hidden = !showingRating
    this.chipSectionTarget.hidden = showingRating
    this.setFieldsDisabled(this.ratingSectionTarget, !showingRating)
    this.setFieldsDisabled(this.chipSectionTarget, showingRating)

    this.chipTabTarget.classList.toggle("btn-active", !showingRating)
    this.ratingTabTarget.classList.toggle("btn-active", showingRating)
  }

  setFieldsDisabled(section, disabled) {
    section.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = disabled
    })
  }
}
